/* eslint-disable consistent-return */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { Box, Icon, Typography } from "@mui/material";
import React from "react";
import LogoJupiter from "src/assets/logotipo.png";
import EsloganJupiter from "src/assets/eslogan.png";
import { Sidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";
import { Link, useLocation } from "react-router-dom";
import { PRIMARIO, SECUNDARIO } from "src/styles/styles";
import { Roles } from "src/utils/roles/roles";
import { setBreadcrumbs } from "src/redux/features/breadcrumbSlice";
import { useAppDispatch } from "src/redux/store";
import { SidebarFooter } from "./SidebarFooter";

export interface MenuItemLateral {
  id: string;
  label: string;
  path?: string;
  esPathDinamico?: boolean;
  icon?: string;
  expanded?: boolean;
  items?: MenuItemLateral[];
  labelTooltip?: string;
  rolesConAcceso: Roles[];
}

export interface ItemRecursivoProps {
  item: MenuItemLateral;
}

const ItemRecursivo = ({ item }: ItemRecursivoProps) => {
  const dispatch = useAppDispatch();
  const { pathname } = useLocation();
  if (item.items) {
    return (
      <SubMenu
        label={
          <Typography fontWeight="bold" sx={{ breakInside: "auto" }}>
            {item.label}
          </Typography>
        }
        defaultOpen={item.expanded}
        icon={item.icon && <Icon>{item.icon}</Icon>}
      >
        {item.items.map((subItem) => (
          <ItemRecursivo key={subItem.id} item={subItem} />
        ))}
      </SubMenu>
    );
  }
  return (
    <MenuItem
      active={item.path ? pathname.includes(item.path) : false}
      key={item.id}
      icon={item.icon && <Icon>{item.icon}</Icon>}
      onClick={() => {
        dispatch(
          setBreadcrumbs([{ label: item.label, url: item.path || "/" }]),
        );
      }}
      component={item.path && <Link to={item.path} />}
    >
      <Typography
        fontWeight={item.icon ? "bold" : "normal"}
        sx={{ breakInside: "auto" }}
      >
        {item.label}
      </Typography>
    </MenuItem>
  );
};

export interface SidebarRProps {
  menuItems: MenuItemLateral[];
}

const SidebarR = ({ menuItems }: SidebarRProps) => {
  const [collapsed, setCollapsed] = React.useState(false);
  return (
    <Sidebar collapsed={collapsed}>
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="space-between"
        height="100%"
      >
        <Menu
          menuItemStyles={{
            button: ({ level, active, disabled }) => {
              // only apply styles on first level elements of the tree

              return {
                textAlign: "left",
                color: active ? PRIMARIO : "black",
                borderLeft: active ? `4px solid ${PRIMARIO}` : "none",
              };
            },
          }}
        >
          <MenuItem
            icon={<img src={LogoJupiter} alt="Logo Jupiter" width="100%" />}
            onClick={() => {
              setCollapsed(!collapsed);
            }}
            style={{ textAlign: "center" }}
          >
            {" "}
            <img src={EsloganJupiter} alt="Logo Jupiter" width="100%" />
          </MenuItem>
          <br />
          {menuItems.map((item) => (
            <ItemRecursivo key={item.id} item={item} />
          ))}
        </Menu>
        <SidebarFooter collapsed={collapsed} />
      </Box>
    </Sidebar>
  );
};

export default SidebarR;
